import {Popover, Transition} from '@headlessui/react';
import {Bars3Icon} from '@heroicons/react/24/solid';

import {Link} from 'gatsby';
import React, {Fragment} from 'react';

import logo from '_images/logo-v2.svg';

const menu = [
  {
    label: 'Home',
    link: '/',
    target: 'self',
  },
  {
    label: 'Projects',
    link: '/projects',
    target: 'self',
  },
  // {
  //   label: 'SunnyTrust',
  //   link: '/sunny-trust',
  // },
  {
    label: 'Articles',
    link: '/articles',
    target: 'self',
  },
  {
    label: 'Films',
    link: '/sunny-morning-films',
    target: 'self',
  },
  {
    label: 'Partners',
    link: '/partners',
    target: 'self',
  },
  {
    label: 'Event',
    link: 'https://event.sunnyside.sg/?utm_source=web_sunnyside&utm_medium=website&utm_campaign=ssid_fair_2025&utm_id=ssid_fair_2025&utm_content=web_navigation_menu',
    target: '_blank',
  },
];

const Header = () => {
  return (
    <div className="pt-[72px] lg:pt-[94px]">
      <div className="bg-[#060606] fixed w-full h-[72px] lg:h-[94px] z-50 top-0">
        <div className="max-w-section mx-auto px-4 lg:px-20 py-4 lg:py-6 flex justify-center lg:justify-between items-center gap-10">
          <Link to="/" className="order-2">
            <img
              src={logo}
              className="w-[162px] lg:w-[182px]"
              alt="SunnySideSG"
            />
          </Link>
          <div className="gap-10 items-center hidden lg:flex order-3 font-nh">
            {menu.map((item, index) => (
              <Link
                key={index}
                to={item.link}
                target={item.target}
                className="font-medium text-primary hover:text-white">
                {item.label}
              </Link>
            ))}
            <Link
              to="/enquire-now"
              className="inline-flex ml-4 px-4 py-2 font-semibold text-lg text-white bg-primary border-2 border-primary rounded-md hover:text-[#060606] hover:bg-primary hover:border-primary webian-button-3">
              Enquiry
            </Link>
          </div>
          <div className="block absolute left-0 top-1/2 -translate-y-1/2 lg:hidden">
            <Popover>
              <Popover.Button className="inline-flex items-center ml-2.5">
                <Bars3Icon className="h-8 w-8 text-white" />
              </Popover.Button>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1">
                <Popover.Panel className="absolute left-0 right-0 z-30 flex w-screen max-w-max">
                  <div className="w-screen flex-auto overflow-hidden text-sm leading-6 shadow-lg bg-primary mt-4 font-nh">
                    <div className="py-2 ml-4 mt-4">
                      {menu.map(item => (
                        <Link
                          key={item.link}
                          to={item.link}
                          className="block p-2.5 font-medium text-white hover:text-dark-blue">
                          {item.label}
                        </Link>
                      ))}
                      <div className="pl-2.5 my-4 w-[200px]">
                        <Link
                          to="/enquire-now"
                          className="inline-flex bg-transparent px-4 py-2 font-semibold text-lg text-white border border-white rounded-md hover:bg-dark-blue hover:border-blue2">
                          Enquiry
                        </Link>
                      </div>
                    </div>
                  </div>
                </Popover.Panel>
              </Transition>
            </Popover>
          </div>
        </div>
      </div>
      {/* <div className="bg-[#FFF3DE] p-4">
        <div className="text-center text-xs lg:text-base text-[#1C3E58] font-medium">
          Worried about your upcoming reno project?{' '}
          <Link to="/sunny-trust" className="inline underline">
            Learn more about SunnyTrust
          </Link>{' '}
          and how it can protect you.
        </div>
      </div> */}
    </div>
  );
};

export default Header;
